import * as React from 'react'

import LazyHydrate, { LazyProps } from './lazy-hydrate'

import ClientOnly from 'app/components/ClientOnly'

/* eslint-disable react/display-name */
export const withHydrateOnVisible =
  <P extends object>(Component: React.ComponentType<P>, lazyProps?: Partial<LazyProps>) =>
  (props: P) => (
    <LazyHydrate whenVisible noWrapper {...lazyProps}>
      <Component {...props} />
    </LazyHydrate>
  )

export const withoutHydration =
  <P extends object>(Component: React.ComponentType<P>, lazyProps?: Partial<LazyProps>) =>
  (props: P) => (
    <LazyHydrate ssrOnly noWrapper {...lazyProps}>
      <Component {...props} />
    </LazyHydrate>
  )

export const withClientOnly =
  <P extends object>(Component: React.ComponentType<P>) =>
  (props: P) => (
    <ClientOnly>
      <Component {...props} />
    </ClientOnly>
  )
